import styled from 'styled-components';
import {
  screenSize,
  inputBorderColor,
  whiteColor,
  mediumFont,
  boldFont,
  appHeaderColor,
  regularFont,
} from '@app/styles';

type Props = {
  active?: boolean;
  open?: boolean;
};
type buttonProps = {
  disabled: boolean;
};
export const BackgroundContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 60px);
  width: 100%;
  margin-top: 60px;
  overflow: hidden;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const Container = styled.div`
  width: 100%;
  height: 100%;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
`;
export const TransactionButton = styled.div`
  font-size: 14px;
`;
export const SideNav = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  background-color: #f4f5f7;
  @media (${screenSize.tablet}) {
    width: 330px;
    border-left: none;
    border-right: 1px solid ${inputBorderColor};
    border-bottom: 2px solid ${inputBorderColor};
  }
`;
export const DesktopSideNav = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const CloseButton = styled.div`
  display: flex;
  height: 48px;
  justify-content: fflex-start;
  background-color: #f4f5f7;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const ListView = styled.div`
  width: 100%;
  height: 100%;
  dispaly: flex;
  flex-direction: column;
  background-color: ${whiteColor};
  overflow-x: hidden;
  overflow-y: auto;
  @media (${screenSize.tablet}) {
    width: calc(100vw - 330px);
    height: 100%;
  }
`;
export const MobileHeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px 10px 10px 22px;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const MobileFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const MobileCreate = styled.div`
  width: 40px;
  height: 40px;
  background-color: ${appHeaderColor};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: fixed;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const MainHeading = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: flex;
    justify-content: space-between;
    font-size: 24px;
    color: #080707;
    ${boldFont}
    padding: 30px 40px 0px 40px;
  }
`;

export const SearchContainer = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 30px 0px 0px 40px;
  }
`;

export const SearchText = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    font-size: 18px;
    color: #080707;
    ${boldFont}
  }
`;

export const SearchHeading = styled.div`
  display: none;
  @media (${screenSize.tablet}) {
    display: block;
    font-size: 18px;
    color: #080707;
    ${mediumFont}
    padding-right: 5px;
  }
`;

export const MobileHeading = styled.div`
  font-size: 20px;
  color: #080707;
  ${boldFont};
  padding-right: 10px;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const GridContainer = styled.div`
  width: 100%;
  cursor: pointer;
  margin: 15px 0px;
  padding: 0px 8px;
  @media (${screenSize.tablet}) {
    margin: 20px 0px;
    padding: 0px 40px;
  }
`;

export const TransactionCard = styled.div`
  min-height: 100px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 0px 10px 20px;
  background-color: rgb(244, 245, 246);
  border: 1px solid rgb(244, 245, 246);
  &:hover {
    background: rgb(244 247 251);
    border: 1px solid rgb(222 225 232);
    box-shadow: hsl(215 8% 44% / 0.1) 0px 5px 10px 0px;
  }
  @media (${screenSize.tablet}) {
    min-height: 96px;
  }
`;

export const Loader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 12px 18px 10px 10px;
  margin: 10px 10px;
  border-radius: 15px;
  background-color: #f4f5f6;
  @media (${screenSize.tablet}) {
    margin: 10px 40px;
    padding: 12px 18px 10px 20px;
  }
`;

export const TransactionCode = styled.div`
  font-size: 12px;
  font-style: normal;
  opacity: 0.6;
  color: #202731;
  line-height: 16px;
  mix-blend-mode: normal;
  ${boldFont}
`;

export const TransactionDetails = styled.div`
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const TransactionStatus = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 15px;
  align-self: center;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding-right: 0px;
    > div {
      &:first-child {
        width: 150px;
        text-align: right;
        margin-right: 20px;
      }
      &:last-child {
        margin-right: 30px;
        text-align: left;
      }
    }
  }
`;

export const StatusOutliner = styled.div``;

export const PropertyLocation = styled.div`
  font-size: 16px;
  color: #202731;
  ${boldFont};
  font-style: normal;
  line-height: 25px;
  align-self: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  @media (${screenSize.tablet}) {
    font-size: 18px;
  }
`;
export const PendingText = styled.div`
  font-size: 14px;
  color: #d63763;
  ${boldFont}
  line-height: 19px;
  font-style: normal;
  text-align: right;
  @media (${screenSize.tablet}) {
    font-size: 14px;
  }
`;
export const TransactionUser = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  @media (${screenSize.tablet}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const CreatedText = styled.div`
  font-size: 12px;
  opacity: 0.5;
  color: #202731;
  font-style: normal;
  ${regularFont};
  line-height: 19px;
  @media (${screenSize.tablet}) {
    font-size: 14px;
  }
`;
export const CreatedByText = styled.div`
  font-size: 12px;
  opacity: 0.5;
  padding-left: 5px;
  color: #202731;
  line-height: 19px;
  @media (${screenSize.tablet}) {
    font-size: 14px;
  }
`;
export const LastUpdatedText = styled.div`
  font-size: 12px;
  opacity: 0.5;
  padding-left: 10px;
  color: #202731;
  line-height: 19px;
  font-style: normal;
  ${regularFont};
  mix-blend-mode: normal;
  @media (${screenSize.tablet}) {
    font-size: 14px;
  }
`;

export const SideNavContainer = styled.div`
  width: 100%;
  height: 100%;
  padding-left: 10px;
  @media (${screenSize.tablet}) {
    padding: 0px;
  }
`;
export const TransactionsNav = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  border-bottom: 1px solid #e5e7ea;
  padding: 15px 0px;
  margin-right: 10px;
  @media (${screenSize.tablet}) {
    padding: 15px;
    margin: 0px;
  }
`;
export const NavItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding-left: 10px;
   height: 48px;
   width:280px;
   border: 1px solid #f4f5f7;
  ${({ active }: Props) => {
    if (active) {
      return `
        background-color: #E9EBF0;
        border-radius: 8px;
        border: 1px solid #E9EBF0;
      `;
    }
  }}
  @media (${screenSize.tablet}) {
    padding-left: 25px;
    width: 288px;
 
  }
`;
export const NavText = styled.div`
  font-size: 15px;
  color: #100f1f;
  line-height: 22px;
  cursor: pointer;
  font-style: normal;
  line-height: 22px;
  ${regularFont};
  ${({ active }: Props) => {
    if (active) {
      return `
           color:#D63763;
      `;
    }
  }}
`;

export const TranscationLogo = styled.div`
  height: 16px;
  width: 12px;
  cursor: pointer;
  margin-right: 10px;
  ${({ active }: Props) => {
    if (active) {
      return `
      svg {
    path{
      fill: #D63763;
    }
  }
      `;
    }
  }}
`;

export const FiltersContainer = styled.div`
  padding-left: 15px;
  padding-right: 10px;
  height: calc(100% - 156px);
  overflow: auto;
  @media (${screenSize.tablet}) {
    padding-left: 35px;
    padding-right: 0px;
  }
`;

export const FilterBox = styled.div`
  padding: 5px 0px;
  padding-right: 15px;
  border-bottom: 1px solid #dee0e0;
`;

export const FilterHeader = styled.div`
  display: flex;
  align-items: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: 600;
  cursor: pointer;
`;

export const FilterTitle = styled.div`
  flex: 1;
  font-style: normal;
  font-size: 14px;
  line-height: 19px;
  ${boldFont};
  color: #110f1f;
  mix-blend-mode: normal;
  opacity: 0.6;
`;

export const FilterIcon = styled.div``;

export const FilterBody = styled.div`
  // max-height: 350px;
  overflow-x: hidden;

  ${({ isOpened }: { isOpened: boolean }) => {
    if (!isOpened) {
      return `
        display: none;
      `;
    }
  }}
  .rdrCalendarWrapper {
    display: flex;
    .rdrMonth {
      width: 100%;
    }
  }
`;

export const FilterOption = styled.div`
  &:last-child {
    > div {
      border-bottom: none;
      padding-bottom: 0px;
    }
  }
`;

export const SubFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const MunicipalityText = styled.div`
  font-size: 14px;
  color: #545760;
  ${boldFont}
`;

export const CheckboxContainer = styled.div`
  padding: 8px 0px;
  border-bottom: 1px solid #e5e7ea;
  &:last-child {
    > div {
      margin-bottom: 0px;
    }
  }
  @media (${screenSize.tablet}) {
    div {
      margin: 5px 0px;
    }
  }
`;
export const SeeMore = styled.div`
  font-size: 14px;
  color: #110f1f;
  padding: 15px 0px;
  padding-bottom: 0px;
  cursor: pointer;
`;
export const FilterText = styled.div`
  font-size: 14px;
  color: #545760;
  padding: 15px 0px;
  ${boldFont};
  cursor: pointer;
  border-bottom: 1px solid #e5e7ea;
`;
export const ButtonItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 15px 15px 0px 0px;
  @media (${screenSize.tablet}) {
    padding: 18px 15px 20px 0px;
  }
`;
export const ButtonContainer = styled.div`
  width: 120px;
  button {
    height: 42px;
    padding: 10px 15px;
  }
  ${({ disabled }: buttonProps) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
`;

export const ResetContainer = styled.div`
  width: 120px;
  margin-right: 20px;
  button {
    height: 42px;
    padding: 10px 15px;
  }
  ${({ disabled }: buttonProps) => {
    if (disabled) {
      return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
    }
  }}
`;
export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0px 40px;
  border-radius: 15px;
  @media (${screenSize.tablet}) {
    background: #f4f5f6;
    height: 50px;
    margin-bottom: 40px;
    flex-direction: row;
    &:hover {
      background-color: rgb(243 247 253);
    }
  }
`;

export const SeeMoreContainer = styled.div`
  width: 100%;
  @media (${screenSize.tablet}) {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const SeeMoreText = styled.div`
  fontsize: 18px;
  ${boldFont};
  color: #17335a;
`;

export const NoDataText = styled.div`
  font-size: 20px;
  ${boldFont};
  color: black;
  opacity: 0.5;
`;

export const NoDataCard = styled.div`
  height: 70%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (${screenSize.tablet}) {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const ListContainer = styled.div`
  height: 100%;
  @media (${screenSize.tablet}) {
    padding-bottom: 80px;
  }
`;

export const MobileContainer = styled.div`
  border-top: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column-reverse;
  padding: 0px 10px 20px 0px;
  height: 60px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  flex-direction: row;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;

export const StyledMenu = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #f4f5f7;
  transform: ${({ open }: Props) =>
    open ? 'translateX(0)' : 'translateX(100%)'};
  height: 100%;
  width: 100%;
  z-index: 5;
  text-align: left;
  position: absolute;
  top: 0;
  right: 0;
  transition: transform 0.5s ease-in-out;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
